export default __webpack_public_path__ + "52f7530b4c95b61f6fae6ecb81ea81b0.png";